export default "__VITE_ASSET__qT02Ds3u__"